import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps, DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import { SpaceCreationDialog } from '../../Space';
import type { CreateSiteSectionDialogProps } from './CreateSiteSectionDialog';

export interface CreateSiteSectionButtonProps
    extends Omit<CreateSiteSectionDialogProps, 'space'>,
        Pick<ButtonProps, 'className' | 'label' | 'size' | 'kind'> {
    siteStructure: api.SiteStructure;
}

export function CreateSiteSectionButton(props: CreateSiteSectionButtonProps) {
    const { className, label, size, kind = 'secondary', siteStructure, ...dialogProps } = props;
    return (
        <>
            <DialogRoot>
                <DialogTrigger>
                    <Button
                        kind={kind}
                        leadingIcon={Icon.AddSiteSection}
                        label={label}
                        className={className}
                        size={size}
                    />
                </DialogTrigger>
                <SpaceCreationDialog
                    target={{ type: 'siteSection', siteStructure, props: dialogProps }}
                    organizationId={props.organization.id}
                />
            </DialogRoot>
        </>
    );
}
